// global
import React, { Component } from 'react';
import { Popup, Image, Grid } from 'semantic-ui-react';
// local
// css
import './ListLabel.css';
// image
import ic_flow_alert_gray from 'app/_assets/img/ic_flow_alert_gray.png';

const Content = () => {
    return (
        <Grid columns={2}>
            <Grid.Row>
                <Grid.Column id="state">
                    <div className="column-title">LINHAS EM ALERTAS</div>
                    <div className="alert-row">
                        <div className='alert-info red' /> Término em menos de 48 horas, bateria baixa ou plug de pressão desconectado.
                    </div>
                    <div className="alert-row">
                        <div className='alert-info orange' /> Dispositivos sem enviar mensagem há 24 horas.
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

class ListLabel extends Component {
    render() {
        return (
            <Popup id="popup-list-legend" trigger={<Image id="popup-map-legend-trigger" src={ic_flow_alert_gray} />} content={<Content />} />
        );
    }
}

export default ListLabel;
